<template>
  <div>
    <carousel >
        <videoCard v-for="(course, i) in courses" :key="i + 1"
          :img_link="course.img_link"
          :chapterName="course.description"
          :chapterIndex="t"
          />
    </carousel>
    <!-- <carousel>
      <videoCard v-for="n in 4" :key="n"/>
    </carousel> -->
      <el-dialog center :visible.sync="modals.result">
        <div id="result" align="center"><h4>{{this.result}}</h4></div><br />
        <div align="center">
          <br /><button title="finalizar" @click.prevent="closeModal('result')" class="col-lg-3 col-md-3 btn-success btn-fill btn-round btn-outline">OK!</button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import videoCard from './CardVideos'
import { Loading, Dialog } from "element-ui";

export default {
  components: {
    [Dialog.name]: Dialog,
    videoCard,
    carousel
  },
  data: () => ({
    modals: {
      result: false,
    },
    result: '',
    courses: [],
    lessonIndex: 0,
    lessonsData: [],
    chapterIndex: 0,
    chaptersData: [],
    chapter: 0,
    chapterName: '',
    nameOfVideoSequence: ''
  }),
  created () {
    this.fetchUserCourses();
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchUserCourses() {
      this.loadingCourses = true;
      this.axios
        .get("/courses")
        .then(response => {
          this.courses = response.data.data;
          this.loadingCourses = false;
          this.listCourses();
        })
        .catch(error => {
          this.result = "Erro ao carregar Cursos. Tente novamente. \n " + error;
          // this.openModal('result');
          console.log(error);
          this.loadingCourses = false;
        });
    },
    openCourse(index) {
      this.open = "ShowCourse";
      this.courseIndex = index;
    },
    playLesson(lesson, lessonIndex, lessons, chapterIndex, chapters) {
      this.lessonIndex = lessonIndex;
      this.lessonsData = lessons;
      this.watchLesson = lesson;
      this.chapterIndex = chapterIndex;
      this.chaptersData = chapters;
      this.tempWatchedLesson = this.watchLesson.watched;
      this.tempReviewLesson = this.watchLesson.review;
      this.open = "playLesson";

      // Scroll to top
      var element = document.getElementById("topDiv");
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    },
    sequence() {
      let lessonIndex = -1;
      let chapterIndex = -1;
      let lessonIndexNoOpcional = -1;
      let chapterIndexNoOpcional = -1;
      let lessonWithOpcional = -1;
      let lessonNoOpcional = -1;
      let lessonsNoOpcional = -1;
      let lessons = [];
      let first = false;
      for (
          let chapter = 0;
          chapter < this.courses[this.courseIndex].chapters.data.length;
          chapter++
      ) {
          lessons = this.courses[this.courseIndex].chapters.data[chapter].lessons.data;
          lessonWithOpcional = _.findIndex(
              lessons,
              function(o) {
                  return o.watched === null;
              }
          );
          if (lessonWithOpcional !== -1 && !first) {
              chapterIndex = chapter;
              lessonIndex = lessonWithOpcional;
              first = true;
          }
          lessonNoOpcional = _.findIndex(
              lessonsNoOpcional,
              function(o) {
                  return o.watched === null && o.required !== 0;
              }
          );
          if (lessonNoOpcional !== -1) {
              chapterIndexNoOpcional = chapter;
              lessonIndexNoOpcional = lessonNoOpcional;
          } else {
              chapterIndexNoOpcional = -1;
              lessonIndexNoOpcional = -1;
          }
      }
      return { lessonIndex, chapterIndex, lessonIndexNoOpcional, chapterIndexNoOpcional };
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/SlidersVideos.vue